/**
 * Standardized API error handler
 * @param {Error} error - The error object from axios
 * @param {string} customMessage - Optional custom error message
 * @returns {Object} - Error object with message and severity
 */
export const handleApiError = (error, customMessage = null) => {
  if (error.response) {
    // Server responded with error
    const { status, data } = error.response;
    
    switch (status) {
      case 400:
        return { 
          message: data?.message || data?.error || 'Bad Request. Please check your input.', 
          severity: 'error' 
        };
      case 401:
        return { 
          message: 'Unauthorized. Please login again.', 
          severity: 'error' 
        };
      case 403:
        return { 
          message: 'Forbidden. You don\'t have permission to perform this action.', 
          severity: 'error' 
        };
      case 404:
        return { 
          message: data?.message || 'Resource not found.', 
          severity: 'error' 
        };
      case 429:
        return { 
          message: 'Too many requests. Please try again later.', 
          severity: 'error' 
        };
      case 500:
        return { 
          message: 'Server error. Please try again later.', 
          severity: 'error' 
        };
      case 503:
        return { 
          message: 'Service unavailable. Please try again later.', 
          severity: 'error' 
        };
      default:
        return { 
          message: data?.message || data?.error || 'An error occurred', 
          severity: 'error' 
        };
    }
  } else if (error.request) {
    // Request made but no response
    return { 
      message: 'Network error. Please check your internet connection.', 
      severity: 'error' 
    };
  } else if (error.name === 'AbortError') {
    // Request was cancelled
    return { 
      message: null, // Don't show error for cancelled requests
      severity: 'info' 
    };
  } else {
    // Something else happened
    return { 
      message: customMessage || error.message || 'An unexpected error occurred', 
      severity: 'error' 
    };
  }
};

export default handleApiError;

